import Axios from 'axios'
import csc from '@csc/csc-sdk'

import { getSavedInstrumentsCredentials } from './cscPaymentsServices'

import { OAUTH_API, CSC_PAYMENTS_HOST, CSC_PAYMENTS_SHOP  } from '@/services/Configuration'

import { standardizeCustomer } from '@/services/Standardizers'

import { error, log } from '@/services/Log'

import Account from '@/services/Account'

const legacyMigration = async ({ email, password }) => {
  const credentials = await getSavedInstrumentsCredentials() //ignore overly specific name
  await csc.ShopFront({ credentials, host: CSC_PAYMENTS_HOST }).migrateLegacyLoginProfile({
    identifier: email,
    password,
    shopName: CSC_PAYMENTS_SHOP,
  })
}

// General / login flow
export const getCustomer = async ({ customerId }) => {
  // TODO: We need documentation regarding this API
  try {
    const customer = ((await Axios.post(`${OAUTH_API}/sf/customer/data/`)).data?.data || [])[0]
    if (customer) {
      return standardizeCustomer(customer)
    }
  } catch (err) {
    log('Failed to retrieve Customer', err)
  }
  return null
}

export const signUserIn = async ({ email, password }) => {
  try {
    await legacyMigration({email, password})
  } catch (e) {
    error(e)
  }
  const { data: { success } } = await Account.signUserIn({ email, password })
  if(success){
    await location.reload()
  }
  return success
}


